<template>
    <div class="date-switcher my-3 mx-auto w-25">
        <b-input-group :size="size">
            <b-input-group-prepend>
                <b-button
                    v-b-tooltip.hover
                    title="Vorheriger Monat"
                    variant="outline-secondary"
                    @click="previousMonth"
                >
                    <font-awesome-icon icon="arrow-alt-circle-left" />
                </b-button>
            </b-input-group-prepend>
            <b-select
                ref="dateSelect"
                :options="options"
                v-model="selected"
                @input="changeMonth"
            ></b-select>
            <b-input-group-append>
                <b-button
                    v-b-tooltip.hover
                    title="Dieser Monat"
                    variant="outline-secondary"
                    @click="currentMonth"
                >
                    <font-awesome-icon icon="calendar-alt" />
                </b-button>
                <b-button
                    v-b-tooltip.hover
                    title="Nächster Monat"
                    variant="outline-secondary"
                    @click="nextMonth"
                >
                    <font-awesome-icon icon="arrow-alt-circle-right" />
                </b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
import "./DateSwitcher.scss";

export default {
    name: "DateSwitcher",
    props: {
        prepend: {
            type: Number,
            default: 12
        },
        append: {
            type: Number,
            default: 24
        },
        format: {
            type: String,
            default: "YYYY-MM-DD"
        },
        outputFormat: {
            type: String,
            default: "MMMM YYYY"
        },
        initial: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            selected: this.initial
        };
    },
    computed: {
        options() {
            var options = [];
            var startMonth = this.getCurrentDate();

            var preOptions = [];
            for (
                var prependIndex = 0;
                prependIndex < this.prepend;
                prependIndex++
            ) {
                startMonth.subtract(1, "months");
                preOptions.push({
                    value: startMonth.format(this.format),
                    text: startMonth.format(this.outputFormat)
                });
            }
            options = preOptions.reverse();

            startMonth = this.getCurrentDate();
            options.push({
                value: startMonth.format(this.format),
                text: startMonth.format(this.outputFormat) + " (aktuell)"
            });

            for (
                var appendIndex = 0;
                appendIndex < this.append;
                appendIndex++
            ) {
                startMonth.add(1, "months");
                options.push({
                    value: startMonth.format(this.format),
                    text: startMonth.format(this.outputFormat)
                });
            }
            return options;
        },
        size() {
            const settings = this.$store.getters.getSettings;
            return settings.size || "md";
        }
    },
    created() {
        if (!this.selected) {
            this.currentMonth();
        }
    },
    methods: {
        currentMonth() {
            this.selected = this.getCurrentDate(true);
        },
        previousMonth() {
            var dMoment = this.$moment(this.selected);
            dMoment.subtract(1, "months");
            this.selected = dMoment.format(this.format);
        },
        nextMonth() {
            var dMoment = this.$moment(this.selected);
            dMoment.add(1, "months");
            this.selected = dMoment.format(this.format);
        },
        changeMonth(val) {
            this.$emit("change", val);
        },
        getCurrentDate(format = false) {
            var d = new Date(Date.now());
            d.setDate(1);
            var dMoment = this.$moment(d);
            if (format) {
                return dMoment.format(this.format);
            }
            return dMoment;
        }
    }
};
</script>
